import { apiFetch } from './api';

export interface Template {
  id: string;
  name: string;
  description: string;
  type: 'Lead' | 'Assistente' | 'Ambos';
  model: string;
  status: 'Enabled' | 'Disabled';
  responseDelay: number;
  prompts: Array<{
    role: string;
    content: string;
  }>;
  category: string;
  icon: string;
  isDefault: boolean;
  active: boolean;
}

export interface CreateTemplateRequest {
  name: string;
  description: string;
  type: 'Lead' | 'Assistente' | 'Ambos';
  model: string;
  status?: 'Enabled' | 'Disabled';
  responseDelay: number;
  prompts: Array<{
    role: string;
    content: string;
  }>;
  category: string;
  icon: string;
  isDefault?: boolean;
}

export interface TemplateSearchParams {
  q?: string;
  category?: string;
  type?: string;
}

export async function fetchTemplates(): Promise<Template[]> {
  return apiFetch<Template[]>('/Template', { auth: true });
}

export async function fetchTemplate(id: string): Promise<Template> {
  return apiFetch<Template>(`/Template/${encodeURIComponent(id)}`, { auth: true });
}

export async function createTemplate(template: CreateTemplateRequest): Promise<Template> {
  return apiFetch<Template>('/Template', {
    method: 'POST',
    auth: true,
    body: JSON.stringify(template),
  });
}

export async function updateTemplate(id: string, template: CreateTemplateRequest): Promise<Template> {
  return apiFetch<Template>(`/Template/${encodeURIComponent(id)}`, {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(template),
  });
}

export async function deleteTemplate(id: string): Promise<void> {
  return apiFetch<void>(`/Template/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    auth: true,
  });
}

export async function searchTemplates(params: TemplateSearchParams): Promise<Template[]> {
  const query = new URLSearchParams();
  if (params.q) query.set('q', params.q);
  if (params.category) query.set('category', params.category);
  if (params.type) query.set('type', params.type);
  
  const qs = query.toString();
  const url = `/Template/search${qs ? `?${qs}` : ''}`;
  return apiFetch<Template[]>(url, { auth: true });
}

export async function fetchTemplatesByCategory(category: string): Promise<Template[]> {
  return apiFetch<Template[]>(`/Template/category/${encodeURIComponent(category)}`, { auth: true });
}

export async function fetchTemplatesByType(type: string): Promise<Template[]> {
  return apiFetch<Template[]>(`/Template/type/${encodeURIComponent(type)}`, { auth: true });
}

// Export as default object for easier importing
const templateApi = {
  fetchTemplates,
  fetchTemplate,
  createTemplate,
  updateTemplate,
  deleteTemplate,
  searchTemplates,
  fetchTemplatesByCategory,
  fetchTemplatesByType,
};

export default templateApi;
